import {
  ActionIcon,
  Box,
  Button,
  Flex,
  Group,
  Image,
  LoadingOverlay,
  Modal,
  Pagination,
  Select,
  SimpleGrid,
  Text,
  TextInput,
  Textarea,
  rem,
} from "@mantine/core";
import { DateInput, DatePicker, DatePickerInput } from "@mantine/dates";
import {
  Dropzone,
  FileRejection,
  FileWithPath,
  IMAGE_MIME_TYPE,
  MIME_TYPES,
} from "@mantine/dropzone";
import { isNotEmpty, useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { notifications } from "@mantine/notifications";
import { useQueryClient } from "@tanstack/react-query";
import MyError from "components/MyError";
import TableArticles from "components/TableArticles";
import config from "config";
import dayjs from "dayjs";
import { ImageIcon, Plus, RotateCcw, Search, Upload, X } from "lucide-react";
import { deleteArticle, getArticleById, getSelectDropDown } from "modules/api";
import { useCreateSport } from "modules/news/hooks/useCreateSport";
import { useEditSport } from "modules/news/hooks/useEditSport";
import { useSports } from "modules/news/hooks/useSports";
import { SingleSport, SportsParams } from "modules/news/types";
import { useEffect, useState } from "react";
import { formatFileSize } from "utils/FormatFileSize";

import { Editor } from "primereact/editor";

interface Values {
  name: string;
  about: string;
  description: string;
  publishedAt: string;
  //   photo: string;
}

interface RequestType {
  name: string;
  shortDescription: string;
  description: string;
  photo?: FileWithPath;
}

const Sports = () => {
  const queryClient = useQueryClient();

  const [params, setParams] = useState<SportsParams>({
    from: null,
    to: null,
    search: null,
    page: 1,
    size: 5,
  });
  const [createEditModal, setCreateEditModal] = useState(false);
  const [modalType, setModalType] = useState<"create" | "edit">("create");
  const [sportType, setSportType] = useState("");
  const [sportId, setSportId] = useState<number | null>(null);
  const {
    isSuccess,
    create,
    isLoading: isLoadingCreate,
  } = useCreateSport({ refetch: handleReset });

  const {
    isSuccess: isSuccessUpdate,
    update,
    isLoading: isLoadingUpdate,
  } = useEditSport({ refetch: handleReset, id: sportId });
  const [file, setFile] = useState<FileWithPath[]>([]);
  const [fileArt, setFileArt] = useState<FileWithPath | null>(null);
  const [singleSportImg, setSingleSportImg] = useState<string | null>(null);
  const [selectDropDown, setSelectDropDown] = useState([]);
  const [selectDropDown2, setSelectDropDown2] = useState([]);
  const [dropDownId, setDropDownId] = useState("");
  const [dropDownId2, setDropDownId2] = useState("");
  const [singleSportFile, setSingleSportFile] = useState<string | null>(null);
  const [singleSportImgPath, setSingleSportImgPath] = useState<string[]>([]);
  const [deletedPaths, setDeletedPaths] = useState<string[]>([]);
  const [singleSportFilePath, setSingleSportFilePath] = useState<string | null>(
    null
  );
  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      from: "",
      to: "",
      search: "",
    },

    validate: {
      // email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
    },
  });
  const formCreateSport = useForm({
    mode: "uncontrolled",
    initialValues: {
      nameUz: "",
      nameRu: "",
      nameEn: "",
      caseDescriptionUz: "",
      caseDescriptionRu: "",
      caseDescriptionEn: "",
      longCaseDescriptionUz: "",
      longCaseDescriptionRu: "",
      longCaseDescriptionEn: "",
      categoryId: "",
      releaseDate: "",
      link: "",
      orderNumber: "",
    },

    validate: {
      // name: isNotEmpty(""),
    },
  });
  const [loadingEdit, setLoadingEdit] = useState(false);
  const { error, fetchSports, isLoading, sports } = useSports(params);
  const [value, setValue] = useState<Date | any>(null);
  const [text, setText] = useState<any>("");
  const [text2, setText2] = useState<any>("");
  const [text3, setText3] = useState<any>("");
  const [text4, setText4] = useState<any>("");
  const [text5, setText5] = useState<any>("");
  const [text6, setText6] = useState<any>("");

  useEffect(() => {
    fetchSports(params);

    console.log("🚀 ~ Sports ~ sports:", sports);
  }, [params]);

  // useEffect(() => {
  //   if (isSuccess) {
  //     handleReset();
  //     onClose();
  //   }
  // }, [isSuccess]);

  // useEffect(() => {
  //   if (isSuccessUpdate) {
  //     handleReset();
  //     onClose();
  //   }
  // }, [isSuccessUpdate]);

  function handleReset() {
    formCreateSport.reset();
    setParams({
      from: null,
      to: null,
      search: null,
      page: 1,
      size: null,
    });
    // queryClient.invalidateQueries({ queryKey: ["sports"] });
    fetchSports(params);
    setFile([]);
    onClose();
  }

  function handleResetForm() {
    form.reset();
    form.setFieldValue("search", "");
    setParams({
      from: null,
      to: null,
      search: null,
      page: 1,
      size: 5,
    });
    // queryClient.invalidateQueries({ queryKey: ["sports"] });
    fetchSports(params);
  }

  const reFetch = () => {
    fetchSports(params);
  };

  const onClose: () => void = () => {
    formCreateSport.reset();
    setText("");
    setText2("");
    setText3("");
    setText4("");
    setText5("");
    setText6("");
    setFile([]);
    setFileArt(null);
    setValue(null);
    setSingleSportImgPath([]);
    setSingleSportImg(null);
    setSingleSportFile(null);
    setSingleSportFilePath(null);
    setCreateEditModal((prevent) => !prevent);
    setSportType("");
    setDropDownId("");
  };

  const handlePage = (e: any) => {
    setParams((prev) => ({
      ...prev,
      page: e,
    }));
    console.log("🚀 ~ handlePage ~ e:", e);
  };

  const onSubmit = (e: { from: string; to: string; search: string }) => {
    const { from, to, search } = e;

    setParams((prev) => ({
      ...prev,
      ...(from && { from }),
      ...(to && { to }),
      ...(search && { search }),
    }));
  };

  const handleCreate = async () => {
    await getSelectDrowDownFun();

    setCreateEditModal(true);
    setModalType("create");
  };

  async function getSingleSport(id: number) {
    try {
      setLoadingEdit(true);
      setCreateEditModal(true);
      await getSelectDrowDownFun();

      const res = await getArticleById(id);
      const data: any = res?.data?.data;
      console.log("🚀 ~ getSingleSporttttttttt ~ data:", data);
      const initialDate = dayjs(data.publishedAt);
      console.log("🚀 ~ getSingleSport ~ initialDate:", data.photoPath);
      formCreateSport.setValues({
        nameUz: data?.name?.uz,
        nameRu: data?.name?.ru,
        nameEn: data?.name?.en,
        caseDescriptionUz: data?.caseDescription?.uz,
        caseDescriptionRu: data?.caseDescription?.ru,
        caseDescriptionEn: data?.caseDescription?.en,
        longCaseDescriptionUz: data?.longCaseDescription?.uz,
        longCaseDescriptionRu: data?.longCaseDescription?.ru,
        longCaseDescriptionEn: data?.longCaseDescription?.en,
        categoryId: data?.category?.id,
        releaseDate: data?.releaseDate,
        link: data?.link,
        orderNumber: data?.orderNumber,
      });
      setValue(initialDate);
      setSportId(data.id);
      setDropDownId(String(data?.category?.id));
      setSingleSportImg(data.photoPath);
      console.log(
        "AAAAAA: ",
        data?.photos.map((photo: any) => photo.pathFile)
      );

      setSingleSportImgPath(data?.photos.map((photo: any) => photo.pathFile));
      // data?.photoPath && setSingleSportFile(data.file);
      data?.photoPath && setSingleSportFilePath(data.photoPath);
      console.log("🚀 ~ getSingleSport ~ res:", res?.data?.data);
    } catch (error: any) {
      notifications.show({
        title: `${error?.data?.message}`,
        message: null,
        color: "red",
      });
      console.log("🚀 ~ getSingleSport ~ error:", error);
    } finally {
      setLoadingEdit(false);
    }
  }

  const handleEdit: (id: number) => void = (id: number) => {
    console.log("Handle edit");
    getSingleSport(id);
    // setSportId(id);
    // setCreateEditModal(true);
    setModalType("edit");
  };

  const getSelectDrowDownFun = async () => {
    try {
      const res = await getSelectDropDown();
      setSelectDropDown(res?.data?.data);
      console.log("res: ", res);
    } catch (error: any) {}
  };

  const handleDelete: (id: number) => void = (id: number) => {
    modals.openConfirmModal({
      title: "Iltimos, harakatingizni tasdiqlang",
      children: <Text size="sm">Ushbu portfolioni o'chirmoqchimisiz?</Text>,
      labels: { confirm: "Xa", cancel: "Yo'q" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => deleteSportFunc(id),
    });
  };

  const deleteSportFunc = async (id: number | null) => {
    try {
      const res = await deleteArticle(id);
      notifications.show({
        title: `Muvaffaqiyatli oʻchirildi`,
        message: null,
      });
      setParams({
        from: null,
        to: null,
        search: null,
        page: 1,
        size: null,
      });
      fetchSports(params);
    } catch (error) {
      notifications.show({
        title: `Oʻchirishda xato yuz berdi`,
        message: null,
        color: "red",
      });
      console.log("🚀 ~ deleteSport ~ error:", error);
    }
  };

  const deletePhoto = (fileName: string) => {
    setFile((prev) => prev.filter((file) => file.name !== fileName));
  };
  const deleteFile = () => {
    setFileArt(null);
    setSingleSportFile(null);
  };
  // const preview = file ? (
  //   <Box>
  //     <Image
  //       src={URL.createObjectURL(file)}
  //       onLoad={() => URL.revokeObjectURL(URL.createObjectURL(file))}
  //     />
  //     <Button onClick={deletePhoto} fullWidth mt={10} variant="default">
  //       O'chirish
  //     </Button>
  //   </Box>
  // ) : singleSportImg ? (
  //   <Box>
  //     <Image src={`${config.api.baseURL}/storage/files/${singleSportImg}`} />
  //     <Button onClick={deletePhoto} fullWidth mt={10} variant="default">
  //       O'chirish
  //     </Button>
  //   </Box>
  // ) : null;

  const previewFile = fileArt ? (
    <Box mt={20}>
      <Button
        color="green"
        justify="space-between"
        fullWidth
        rightSection={<X onClick={deleteFile} size={14} />}
        variant="light"
      >
        {fileArt.name}
      </Button>
    </Box>
  ) : singleSportFile ? (
    <Box mt={20}>
      <Button
        color="green"
        justify="space-between"
        fullWidth
        rightSection={<X onClick={deleteFile} size={14} />}
        variant="light"
      >
        {singleSportFile}
      </Button>
    </Box>
  ) : null;

  const onDrop = (acceptedFiles: FileWithPath[]) => {
    setFile((prev) => [...prev, ...acceptedFiles]);
  };

  const onReject = (rejectedFiles: FileRejection[]) => {
    const fileSizeInBytes: number = rejectedFiles[0]?.file.size;
    const formattedSize = `${(fileSizeInBytes / 1024 / 1024).toFixed(2)} MB`;

    notifications.show({
      title: "File Rejected",
      message: `File is larger than ${formattedSize}. Maximum size is 10 MB.`,
      color: "red",
    });
  };

  const handleDeleteImgPath = (imagePath: string) => {
    setDeletedPaths((prev) => [...prev, imagePath]);
    setSingleSportImgPath((prev) => prev.filter((path) => path !== imagePath));
  };

  const onSubmitCreateSport = (values: any) => {
    if (file || singleSportImgPath?.length) {
      const data: any = {
        nameUz: values?.nameUz,
        nameRu: values?.nameRu,
        nameEn: values?.nameEn,
        caseDescriptionUz: values?.caseDescriptionUz,
        caseDescriptionRu: values?.caseDescriptionRu,
        caseDescriptionEn: values?.caseDescriptionEn,
        longCaseDescriptionUz: values?.longCaseDescriptionUz,
        longCaseDescriptionRu: values?.longCaseDescriptionRu,
        longCaseDescriptionEn: values?.longCaseDescriptionEn,
        categoryId: values?.categoryId,
        releaseDate: dayjs(values?.releaseDate).toISOString(),
        link: values?.link,
        orderNumber: values?.orderNumber,

        // ...(file && { photos: file }),
        ...(file && { file }),
        ...(deletedPaths?.length && { deletedPath: deletedPaths }),
        ...(dropDownId !== "null" && { categoryId: dropDownId }),
        // ...(fileArt && { file: fileArt }),
        ...(singleSportImg === null && {
          deletePhotoPath: singleSportImgPath,
        }),
        // ...(singleSportFile === null && {
        //   deleteFilePath: singleSportFilePath,
        // }),
      };

      modalType === "create" ? create(data) : update(data);
    } else {
      notifications.show({
        title: `Iltimos, maqola uchun rasm yuklang`,
        message: null,
        color: "red",
      });
    }
  };

  const onDropArtFile = (file: FileWithPath[]) => {
    setFileArt(file[0]);
  };
  const onRejectArtFile = (file: FileRejection[]) => {
    const fileSizeInBytes: number = file[0]?.file.size;
    const formattedSize: string = formatFileSize(fileSizeInBytes);

    // File is larger than 10485760 bytes
    notifications.show({
      title: `Fayl 20 mb dan katta`,
      message: "20 mb gacha yuklash mumkin",
      color: "red",
    });
  };

  const convertedDataSport: any = selectDropDown?.length
    ? selectDropDown.map((item: any) => {
        return {
          value: item.id.toString(),
          label: item.name,
        };
      })
    : null;

  const convertedDataSport2: any = selectDropDown2?.length
    ? selectDropDown2.map((item: any) => {
        return {
          value: item.id.toString(),
          label: item.name,
        };
      })
    : null;

  const onChangeDropDown = (e: any) => {
    setDropDownId(e);
    console.log("asdasdasd: ", e);
  };
  const onChangeDropDown2 = (e: any) => {
    setDropDownId2(e);
    console.log("asdasdasd: ", e);
  };

  const textHandler = (e: any) => {
    setText(e);
    formCreateSport.setFieldValue("caseDescriptionUz", e);
  };
  const textHandler2 = (e: any) => {
    setText2(e);
    formCreateSport.setFieldValue("caseDescriptionRu", e);
  };
  const textHandler3 = (e: any) => {
    setText3(e);
    formCreateSport.setFieldValue("caseDescriptionEn", e);
  };
  const textHandler4 = (e: any) => {
    setText4(e);
    formCreateSport.setFieldValue("longCaseDescriptionUz", e);
  };
  const textHandler5 = (e: any) => {
    setText5(e);
    formCreateSport.setFieldValue("longCaseDescriptionRu", e);
  };
  const textHandler6 = (e: any) => {
    setText6(e);
    formCreateSport.setFieldValue("longCaseDescriptionEn", e);
  };

  // if (error) return <MyError error={error} />;
  return (
    <div>
      <LoadingOverlay
        visible={isLoading}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />
      <Text size="xl">Filters</Text>
      <Flex align={"end"} justify={"space-between"}>
        <Flex align={"end"}>
          <form
            className="flex items-end"
            onSubmit={form.onSubmit((values) => onSubmit(values))}
          >
            <DateInput
              // value={value}
              // onChange={setValue}
              className="mr-2"
              {...form.getInputProps("from")}
              label="From"
              placeholder="Enter date"
            />
            <DateInput
              // value={value}
              // onChange={setValue}
              className="mr-2"
              {...form.getInputProps("to")}
              label="To"
              placeholder="Enter date"
            />
            <TextInput
              label="Search term"
              placeholder="Please enter a search term."
              {...form.getInputProps("search")}
            />
            <Button
              className="mx-2"
              type="submit"
              rightSection={<Search size={14} />}
            >
              Search
            </Button>
            <ActionIcon
              onClick={handleResetForm}
              size={"input-sm"}
              variant="filled"
              aria-label="Settings"
            >
              <RotateCcw size={14} />
            </ActionIcon>
          </form>
        </Flex>
        <Box>
          <Button rightSection={<Plus size={14} />} onClick={handleCreate}>
            Create
          </Button>
        </Box>
      </Flex>

      <Box className="mt-4">
        <TableArticles
          sports={sports?.items}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
        {sports?.meta && (
          <Flex justify={"center"} mt={20}>
            <Pagination
              onChange={handlePage}
              value={sports.meta.page}
              total={sports.meta.totalPage}
            />
          </Flex>
        )}
      </Box>

      <Modal.Root size={"xl"} opened={createEditModal} onClose={onClose}>
        <LoadingOverlay
          visible={loadingEdit}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title>
              {modalType === "create" ? "Create portfolio" : "Edit portfolio"}
            </Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            <form
              onSubmit={formCreateSport.onSubmit((values: any) =>
                onSubmitCreateSport(values)
              )}
            >
              <Flex
                gap="md"
                justify="flex-start"
                align="flex-start"
                wrap="wrap"
                direction={"column"}
              >
                <Flex gap={"md"} className="w-full">
                  <TextInput
                    className="w-full"
                    label="Name uz"
                    placeholder="Please enter uz name"
                    {...formCreateSport.getInputProps("nameUz")}
                  />
                  <TextInput
                    className="w-full"
                    label="Name ru"
                    placeholder="Please enter ru name"
                    {...formCreateSport.getInputProps("nameRu")}
                  />
                  <TextInput
                    className="w-full"
                    label="Name en"
                    placeholder="Please enter en name"
                    {...formCreateSport.getInputProps("nameEn")}
                  />
                </Flex>
                <Box className="w-full">
                  <Text>Case description uz</Text>
                  <Editor
                    value={text}
                    onTextChange={(e) => textHandler(e.htmlValue)}
                    style={{ height: "320px" }}
                    // {...formCreateSport.getInputProps("caseDescriptionUz")}
                  />
                  {/* <Textarea
                    rows={5}
                    className="w-full"
                    label="Case description uz"
                    placeholder="Please enter uz case description"
                    {...formCreateSport.getInputProps("caseDescriptionUz")}
                  /> */}
                </Box>
                <Box className="w-full">
                  <Text>Case description ru</Text>
                  <Editor
                    value={text2}
                    onTextChange={(e) => textHandler2(e.htmlValue)}
                    style={{ height: "320px" }}
                    // {...formCreateSport.getInputProps("caseDescriptionUz")}
                  />
                </Box>
                <Box className="w-full">
                  <Text>Case description en</Text>
                  <Editor
                    value={text3}
                    onTextChange={(e) => textHandler3(e.htmlValue)}
                    style={{ height: "320px" }}
                    // {...formCreateSport.getInputProps("caseDescriptionUz")}
                  />
                </Box>
                <Box className="w-full">
                  <Text>Long case description uz</Text>
                  <Editor
                    value={text4}
                    onTextChange={(e) => textHandler4(e.htmlValue)}
                    style={{ height: "320px" }}
                    // {...formCreateSport.getInputProps("caseDescriptionUz")}
                  />
                </Box>
                <Box className="w-full">
                  <Text>Long case description ru</Text>
                  <Editor
                    value={text5}
                    onTextChange={(e) => textHandler5(e.htmlValue)}
                    style={{ height: "320px" }}
                    // {...formCreateSport.getInputProps("caseDescriptionUz")}
                  />
                </Box>
                <Box className="w-full">
                  <Text>Long case description en</Text>
                  <Editor
                    value={text6}
                    onTextChange={(e) => textHandler6(e.htmlValue)}
                    style={{ height: "320px" }}
                    // {...formCreateSport.getInputProps("caseDescriptionUz")}
                  />
                </Box>

                <Flex gap={"md"} className="w-full">
                  <DateInput
                    className="w-full"
                    label="Release date"
                    placeholder="Please enter release price"
                    {...formCreateSport.getInputProps("releaseDate")}
                  />
                  <TextInput
                    className="w-full"
                    label="Link"
                    placeholder="Please enter link"
                    {...formCreateSport.getInputProps("link")}
                  />
                </Flex>

                <Flex gap={"md"} className="w-full">
                  <Select
                    // {...{
                    //   onChange: (newValue, options) =>
                    //     onChangeDropDown(newValue),
                    //   error: form.errors.sportId,
                    //   value: dropDownId,
                    // }}
                    onChange={(e: any) => onChangeDropDown(e)}
                    value={dropDownId}
                    defaultValue={dropDownId}
                    label={"Category"}
                    placeholder="Select any category"
                    data={convertedDataSport}
                    className="w-full"
                  />
                  <TextInput
                    className="w-full"
                    label="Order number"
                    placeholder="Please enter order number"
                    {...formCreateSport.getInputProps("orderNumber")}
                  />
                </Flex>

                <Box className="w-full">
                  <Text size="sm">Photo for category</Text>
                  <Dropzone
                    className="w-full"
                    onDrop={(file) => onDrop(file)}
                    onReject={(file) => onReject(file)}
                    maxSize={10 * 1024 ** 2}
                    accept={IMAGE_MIME_TYPE}
                    // {...props}
                  >
                    <Group
                      justify="center"
                      gap="sm"
                      mih={20}
                      style={{ pointerEvents: "none" }}
                    >
                      <Dropzone.Accept>
                        <Upload
                          style={{
                            width: rem(52),
                            height: rem(52),
                            color: "var(--mantine-color-blue-6)",
                          }}
                          //   stroke={1.5}
                        />
                      </Dropzone.Accept>
                      <Dropzone.Reject>
                        <X
                          style={{
                            width: rem(52),
                            height: rem(52),
                            color: "var(--mantine-color-red-6)",
                          }}
                          //   stroke={1.5}
                        />
                      </Dropzone.Reject>
                      <Dropzone.Idle>
                        <ImageIcon
                          style={{
                            width: rem(42),
                            height: rem(42),
                            color: "var(--mantine-color-dimmed)",
                          }}
                          //   stroke={1.5}
                        />
                      </Dropzone.Idle>

                      <div>
                        <Text size="lg" inline>
                          Drag an image here or click to select an image
                        </Text>
                        <Text size="sm" c="dimmed" inline mt={7}>
                          Upload one image, the image should not exceed 5mb.
                        </Text>
                      </div>
                    </Group>
                  </Dropzone>
                  <SimpleGrid cols={{ base: 1, sm: 4 }} mt={"xl"}>
                    {file.map((file) => {
                      const previewUrl = URL.createObjectURL(file);

                      return (
                        <Box key={file.name}>
                          <Image src={previewUrl} />
                          <Text style={{ flexGrow: 1 }}>{file.name}</Text>
                          <Button
                            fullWidth
                            mt={10}
                            variant="default"
                            onClick={() => {
                              deletePhoto(file.name);
                              URL.revokeObjectURL(previewUrl); // URL ni o'chirishni faqat kerak bo'lgan joyda qiling
                            }}
                          >
                            <X size={16} />
                          </Button>
                        </Box>
                      );
                    })}
                    {singleSportImgPath.map((path, index) => (
                      <Box key={index} style={{ position: "relative" }}>
                        <Image
                          src={`http://185.74.6.117:8012/api/storage/files/${path}`}
                          alt={`Preview ${index}`}
                          width={100}
                          height={100}
                          // withPlaceholder
                        />
                        <Button
                          size="xs"
                          color="red"
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                          }}
                          onClick={() => handleDeleteImgPath(path)}
                        >
                          Delete
                        </Button>
                      </Box>
                    ))}
                  </SimpleGrid>
                </Box>
              </Flex>
              <Flex justify={"end"} mt={20}>
                <Box>
                  <Button variant="default" mr={10} onClick={onClose}>
                    Close
                  </Button>
                  <Button
                    loading={isLoadingCreate}
                    className="mx-2"
                    type="submit"
                  >
                    {modalType === "create" ? "Create" : "Update"}
                  </Button>
                </Box>
              </Flex>
            </form>
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>

      {/* <MyModal
        singlesport={singleSport}
        sportid={sportId}
        type={modalType}
        refetch={reFetch}
        onClose={onClose}
        createEditModal={createEditModal}
      /> */}
    </div>
  );
};

export default Sports;
